import './App.css';
import { Routes, Route } from 'react-router-dom';
import routes from './Routing';
import Footer from './components/footer';

function App() {
  return (
    <div className="App">
      <Routes>
        {routes}
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
